  export interface User {
    id: string;
    username: string;
    discriminator: string;
    avatarUrl: string;
    status: 'online' | 'idle' | 'dnd' | 'offline';
    isBot?: boolean;
    isMuted?: boolean;
    isDeafened?: boolean;
    isVideoOn?: boolean;
    isScreenSharing?: boolean;
    isPremium?: boolean;
    isElite?: boolean;
    isLegendary?: boolean;
    isShowcase?: boolean; 
    purchasedItems?: string;
    plan?: 'standard' | 'premium' | 'elite';
    subscriptionDate?: number | string | Date; 
    selectedFrame?: 'standard' | 'premium' | 'elite' | 'legendary' | 'showcase'; 
    about?: string;
    bannerUrl?: string | null;
    accentColor?: string;
    email?: string;
    phone?: string;
    dmFilterLevel?: 'safe' | 'friends' | 'none';
    theme?: 'dark' | 'light';
    messageDisplay?: 'cozy' | 'compact';
    fontScale?: number;
    role?: 'USER' | 'MODERATOR' | 'ADMIN' | 'FOUNDER';
    
    // 👇 SİSTEME SONRADAN EKLENEN SES VE BİLDİRİM ÖZELLİKLERİ 👇
    selectedInputId?: string;
    selectedOutputId?: string;
    micVolume?: number;
    outputVolume?: number;
    inputMode?: 'activity' | 'ptt';
    pttKey?: string;
    audioOutputMode?: 'mono' | 'stereo' | 'smart';
    desktopNotifications?: boolean;
    pushNotifications?: boolean;
    emailNotifications?: boolean;
    ttsNotifications?: boolean;
    soundNotifications?: boolean;
    is2FAEnabled?: boolean;
    echoCancellation?: boolean;
    noiseSuppression?: boolean;
    autoGainControl?: boolean;

// 🚀 İŞTE KIRMIZI YAKAN EKSİK HUKUK/ANALİTİK MÜHÜRLERİ BURADA 👇
    birthday?: string;
    parentalConsent?: boolean;
    allowAnalytics?: boolean;

// 🚀 YENİ: 3D UZAMSAL SES MÜHRÜ 👇
    spatialAudio?: boolean;

    // 🚀 YENİ: ARKA PLAN AKTİVİTE PANELİ (Masaüstü - Discord Benzeri)
    showActivityPanel?: boolean;
  }
  export interface Member {
    id: string;
    username: string;
    discriminator: string; 
    avatarUrl: string;
    bannerUrl?: string | null;
    status: 'online' | 'idle' | 'dnd' | 'offline';
    roleId: string;
    statusText?: string;
    color?: string;
    joinDate?: string;
    isBot?: boolean;
    isPremium?: boolean;
    isElite?: boolean;
    isLegendary?: boolean;
    isShowcase?: boolean; 
    selectedFrame?: 'standard' | 'premium' | 'elite' | 'legendary' | 'showcase';
    plan?: 'standard' | 'premium' | 'elite';
    // Backend'den gelen XP ve Level verileri
    xp?: number;
    level?: number;

    botId?: string; // Botların kimliği için
  }

export interface Friend {
  id: string;
  username: string;
  avatarUrl: string;
  status: 'online' | 'idle' | 'dnd' | 'offline';
  relationship: 'friend' | 'incoming' | 'outgoing' | 'none' | 'blocked';
  isDmOpen?: boolean; 
  isBot?: boolean;
  unreadCount?: number;
  isPremium?: boolean;
  isElite?: boolean;
  isLegendary?: boolean;
  plan?: 'standard' | 'premium' | 'elite';
}

  export interface PulseActivity {
    id: number;
    title: string;
    subtitle: string;
    server: string;
    users: string[];
    image: string;
    type: 'game' | 'stream' | 'music' | 'event';
  }

  export interface Message {
    id: string;
    senderId: string;
    content: string;
    timestamp: string;
    isEdited?: boolean;
    type: 'text' | 'system' | 'file' | string; // 🚀 TS MÜHRÜ: string eklendi, artık "type eşleşmiyor" hatası vermeyecek!
    attachment?: {
      name: string;
      size: number;
      url: string;
      mimeType: string;
    };
    isPremiumSender?: boolean; 
    isShowcaseSender?: boolean; 
    selectedFrameSender?: 'standard' | 'premium' | 'elite' | 'legendary' | 'showcase';

  replyToId?: string;
    replyTo?: {
      id: string;
      content: string;
      sender: { username: string; avatarUrl?: string }; // 🚀 avatarUrl buraya eklendi!
    };
    
    // 👇 SİSTEME SONRADAN EKLENEN VE KIZARAN MÜHÜRLER 👇
    sender?: any;      // Mesajın içine gömülü kullanıcı objesi için
    isGhost?: boolean; // Hayalet mesaj özelliği için

    reactions?: Record<string, string[]>;
  }
  export interface Channel {
    id: string;
    name: string;
    type: 'text' | 'voice';
    voiceMode?: 'standard' | 'ai';
    iconUrl?: string | null;
    bitrate?: 64 | 128 | 240;
    categoryId?: string;
  }

  export interface ChannelFolder {
  id: string;
  name: string;
  channelIds: string[];
}

  export interface Role {
    id: string;
    name: string;
    color: string;
    iconUrl?: string; 
    iconName?: 'Crown' | 'Shield' | 'ShieldCheck' | 'User' | 'Sparkles' | 'Ghost' | 'ShieldAlert'; 
    permissions: string[];
    level?: number;
  }

  export interface LevelReward {
    id?: string;         // 🚀 Eski verilerde ID olmayabileceği için opsiyonel yaptık
    name: string;
    requiredXp?: number; // 🚀 Eski verilerde XP yerine Level kullanıldığı için opsiyonel
    level?: number;      // 🚀 İŞTE KIRMIZI HATAYI VERDİREN EKSİK KELİME EKLENDİ
    iconUrl: string;
  }
  // Varsayılan Rütbe Tanımları (XP Odaklı)
  export const DEFAULT_LEVEL_REWARDS: LevelReward[] = [
    { 
      id: 'dr1', 
      requiredXp: 0, // Başlangıç rütbesi
      name: 'Yeni Üye', 
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/2583/2583290.png' 
    },
    { 
      id: 'dr2', 
      requiredXp: 1000, // 1000 XP olunca
      name: 'Aktif Üye', 
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/2583/2583344.png' 
    },
    { 
      id: 'dr3', 
      requiredXp: 5000, // 5000 XP olunca
      name: 'Sohbet Ustası', 
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/2583/2583319.png' 
    },
    { 
      id: 'dr4', 
      requiredXp: 15000, // 15000 XP olunca
      name: 'Efsanevi', 
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/2583/2583434.png' 
    }
  ];

  export interface Bot {
    id: string;
    botId?: string;
    instanceId?: string; 
    name: string;
    description: string;
    avatarUrl: string;
    bannerUrl?: string; 
    active: boolean;
    config?: any; 
    expiresAt?: string;
  }

  export interface Server {
    id: string;
    name: string;
    iconUrl?: string;
    badgeImage?: string;
    ownerId: string; 
    inviteCode?: string; 
    channels: Channel[];
    roles?: Role[];
    members?: Member[]; 
    bots?: Bot[];
    moderation?: {
      verificationLevel: 'none' | 'low' | 'high' | 'highest';
      explicitContentFilter: boolean;
    };
    // 👇 SİSTEME SONRADAN EKLENEN ENVANTER VE GÖRÜNÜM MÜHÜRLERİ 👇
    wallpaperUrl?: string | null;
    purchasedWallpapers?: string | null;
    wallpaperBrightness?: number;
    purchasedChannelIcons?: string | null;
    channelFolders?: ChannelFolder[];
  }

  export enum ConnectionState {
    DISCONNECTED = 'disconnected',
    CONNECTING = 'connecting',
    CONNECTED = 'connected',
    ERROR = 'error'
  }

  export const PREMIUM_AVATAR_URLS = [
    'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1540573133985-87b6da6d54a9?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1516934024742-b461fba47600?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1579353977828-2a4eab540b9a?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1575550959106-5a7defe28b56?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1547721064-da6cfb341d50?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1614027164847-1b28cfe1df60?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-11452570053594-1b985d6ea890?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1425082661705-1834bfd09dca?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1563089145-599997674d42?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1618336753974-aae8e04506aa?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=300&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1599839575945-a9e5af0c3fa5?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1618160702438-9b02ab6515c9?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1555685812-4b943f1cb0eb?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1531604250646-2f0e818c4f06?auto=format&fit=crop&w=300&q=80',
    'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=300&q=80',
  ];

  // ==========================
  // 🚀 ÖZEL ARKADAŞ GRUPLARI 
  // ==========================

  export interface GroupChat {
    id: string;
    name?: string;
    iconUrl?: string;
    ownerId: string;
    members: GroupMember[];
    messages?: GroupMessage[];
    createdAt: string;
  }

  export interface GroupMember {
    id: string;
    groupId: string;
    userId: string;
    joinedAt: string;
    user: User; // User tipinden çekiyoruz (id, username, avatarUrl vs. var)
  }

  export interface GroupMessage {
    id: string;
    content: string;
    senderId: string;
    groupId: string;
    fileName?: string | null;
    fileSize?: number | null;
    fileUrl?: string | null;
    fileType?: string | null;
    createdAt: string;
    sender: {
      id: string;
      username: string;
      avatarUrl: string;
    };
  }
